import { ReactNode } from "react";
import { ServiceTitanIconLink } from "./service-titan-icon-link";

interface ServiceTitanExternalLinkProps {
  url: string;
  children: ReactNode;
}

export const ServiceTitanExternalLink = ({
  url,
  children,
}: ServiceTitanExternalLinkProps) => (
  <ServiceTitanIconLink url={url} className="text-sm">
    {children}
  </ServiceTitanIconLink>
);
